import React, { useContext } from 'react';
import { Toolbar } from '@europrocurement/flexy-components';
import { DossierRoutingContext } from '../../../../Dossiers';

export type DetailOrderToolbarProps = {
    id: number;
    reference: string;
};

const DetailOrderToolbar: React.FunctionComponent<DetailOrderToolbarProps> = function (props) {
    const { id, reference } = props;
    const { getOrderRoute, getDossiersListeRoute } = useContext(DossierRoutingContext);

    const breadcrumbPath = [
        {
            link: getOrderRoute(id),
            path: `Commande ${reference}`,
        },
        '',
    ];

    return (
        <Toolbar
            path={breadcrumbPath}
            previousPath={getDossiersListeRoute()}
        />
    );
};

export default DetailOrderToolbar;
